import {
  Directive,
  ElementRef,
  AfterViewInit,
  Input,
  SimpleChanges,
} from "@angular/core";

@Directive({ selector: "[resizable]" })
export class ResizableDirective implements AfterViewInit {
  @Input()
  resizable;

  $el: any;

  constructor(el: ElementRef) {
    this.$el = $(el.nativeElement);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initialize();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initialize();
  }

  initialize() {
    (<any>this.$el).resizable(this.resizable);
  }
}
